import * as React from 'react';
import { FC, ReactNode } from 'react';
import classNames from 'classnames';
import styles from './assets/infoItem.module.scss';

interface Props {
    value: ReactNode | string;
    title: string;
    valueSum: string;
    valueDate: string | null;
}

const InfoRatesItem: FC<Props> = ({ value, title, valueSum, valueDate }: Props) => {
    return (
        <div className={classNames(styles.infoItem)}>
            {title ? <b className={classNames(styles.titleItem)}>{title}</b> : null}
            <span className={classNames(styles.titleItemText)}>
                <b>${valueSum}</b> per hour from <b>{valueDate}</b>
            </span>
        </div>
    );
};

export default InfoRatesItem;
